export const Finance: React.FC = () => {
  return <div>Finance</div>;
};
